import React from 'react';

export const ContextInput = React.createContext();